<div class="chatbot-container" [class.is-card-view]="areVendorCardsVisible()">
    @if (areVendorCardsVisible()) {
        <div class="vendor-card__wrapper">
            <div class="vendor-card__container">
                @if (areNewsVendorsLoading()) {
                    <div class="vendor-card__loading">
                        <mat-spinner [style.margin-left.px]="40" [diameter]="90" [strokeWidth]="8"></mat-spinner>
                        <h2>Loading vendors</h2>
                    </div>
                } @else {
                    @if (newsVendors()?.length) {
                        @for (vendor of newsVendors(); track vendor.code) {
                            <ia-market-scan-vendor-card
                                [logo]="vendor.image_base64"
                                [label]="vendor.name"
                                [description]="vendor.description"
                                [hasAccess]="vendor.has_access || false"
                                (clicked)="onRequestAccess(vendor.code)"
                            />
                        }
                    } @else if (newsVendorsError()?.error) {
                        <section class="vendor-card__error-container">
                            <mat-icon class="vendor-card__no-error-icon">error</mat-icon>
                            <p class="vendor-card__error-message">{{ newsVendorsError().status }} Error getting vendors.</p>
                        </section>
                    } @else {
                        <section class="vendor-card__no-data-container">
                            <mat-icon class="vendor-card__no-data-icon">warning</mat-icon>
                            <p class="vendor-card__no-data-message">No vendors. Contact your system administrator.</p>
                        </section>
                    }
                }
            </div>
        </div>
    } @else {
        <!-- Filter -->
        <ia-chatbot-filter-panel [mode]="mode()" [allVendors]="newsVendors()" [selectedVendor]="vendor()" (filtersChanged)="filtersChanged($event)" />

        <!-- chatbot -->
        <mtx-split direction="horizontal" [restrictMove]="true" [useTransition]="false">
            <mtx-split-pane [size]="50" [minSize]="10" [maxSize]="90" [order]="1">
                <env-chatbot-wc
                    style="position: relative"
                    #chatbot
                    [client]="'sphere'"
                    [genAiWsReconnectionAttempts]="5"
                    [mode]="'bot'"
                    [portable]="false"
                    [botConfig]="botConfig()"
                    [contextField]="'filters'"
                    [context]="context()"
                    [featureToggle]="{
                        allowKeepSession: false,
                        hallucination: false,
                        copyMessage: true,
                        newConversation: true,
                        feedback: true,
                        historyGroupItems: false,
                        history: true,
                        config: false,
                        fileUpload: false,
                        hints: true,
                        historyDeleteAll: false,
                        historyDownloadTranscript: false
                    }"
                    [theme]="'dark'"
                    [themeConfig]="themeConfig"
                    [id]="'sphere'"
                    [demo_features]="true"
                    [genAiFeedbackDomain]="feedbackDomain()"
                    [genAiDomain]="domain()"
                    [genAiWsDomain]="wsDomain()"
                />
            </mtx-split-pane>
            <mtx-split-pane [size]="50" [minSize]="40" [maxSize]="90" [order]="2" [visible]="isPdfViewerVisible()">
                <div class="viewer-section">
                    <div class="viewer-section-toolbar">
                        @if (currentPdfTitle()) {
                            <h3 class="pdf-title" [matTooltip]="currentPdfTitle()">{{ currentPdfTitle() }}</h3>
                        }
                        <button mat-icon-button (click)="closeViewer()" matTooltip="Close">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                    @if (pdfError()) {
                        <div class="error">
                            <section class="error-container">
                                <mat-icon class="error-container__error-icon">error</mat-icon>
                                <p class="error-container__error-message">An error occurred while loading.</p>
                                <a (click)="retry(this.currentPdfId())" class="retry-link">Retry</a>
                            </section>
                        </div>
                    } @else if (isPdfViewerLoading()) {
                        <div class="pdf-loading">
                            <mat-spinner diameter="70" mode="indeterminate" />
                        </div>
                    } @else if (currentPdfUrl()) {
                        <ia-pdf-viewer [pdfData]="{ pdfUrl: currentPdfUrl(), isPDF: isPDF() }" />
                    }
                </div>
            </mtx-split-pane>
        </mtx-split>
    }
</div>
